import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import Edit from '@jda/lui-common-icon-library/ui/Edit';
import UserAdd from '@jda/lui-common-icon-library/ui/UserAdd';
import ArrowChevronsRight from '@jda/lui-common-icon-library/ui/ArrowChevronsRight';
import Link from '@jda/lui-common-icon-library/ui/Link';
import ArrowChevronUp from '@jda/lui-common-icon-library/ui/ArrowChevronUp';
import History from '@jda/lui-common-icon-library/ui/History';
import BubblesUsersCollab from '@jda/lui-common-icon-library/ui/BubblesUsersCollab';
import { makeStyles } from '@material-ui/core/styles';
import { Button, ButtonGroup, Tooltip } from '@material-ui/core';
import * as _ from 'lodash';
import React, { useEffect } from 'react';
import DetailedTable from '../../components/DetailedTable';
import { Loading } from '../../Loading';
import {
  CUSTOMER_PROVIDER_RELATION_QUERY,
  PARTICIPANT_SUBSCRIBED_QUERY,
  SUBSCRIBED_PARTICIPANT_WORKFLOW_QUERY,
  AGGREGATOR_PROVIDER_QUERY,
  CUSTOMER_AGGREGATOR_QUERY,
  USER_DETAILS,
  AGGREGATOR_SUBSCRIBED_QUERY
} from '../graphQL/queries';
import getColumns from './columns';
import ManageRelationDialog from './ManageRelationDialog';
import ViewDetails from '@jda/lui-common-icon-library/ui/ViewDetails';
import Requested from './Requested';
import Chat from './Chat';
import AuthContextDetailView from './AuthContextDetailView';
import { formatString } from '../../utils/helpers';

const useStyles = makeStyles(theme => ({
  progress: {
    color: theme.palette.background.paper
  },
  priorityBarSettings: {
    position: 'relative',
    height: theme.spacing(4),
    width: theme.spacing(0.25)
  },
  widget: {
    '& .rcw-widget-container': {
      position: 'relative',
      margin: 0,
      zIndex: 1
    },
    '& .rcw-launcher': {
      height: '45px',
      width: '45px',
      margin: 0
    }
  }
}));

interface ManageRelationsProps {
  participant: any;
  workflowCode: string;
}

const ManageRelations = (props: ManageRelationsProps) => {
  const classes = useStyles();
  let { participantCode, participantType } = props.participant;

  const { loading: userLoading, data: userData } = useQuery(USER_DETAILS, { fetchPolicy: 'cache-only' });
  const [manageRelation, setManageRelation] = React.useState(false);
  const [existingDisable, setExistingDisable] = React.useState(true);
  const [formData, setFormData] = React.useState({});
  const [chatDialog, setChatDialog] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState({});
  const [selectedKey, setSelectedKey] = React.useState('ENABLED');
  const [userRole, setUserRole] = React.useState('');
  const [requestDialog, setRequestDialog] = React.useState(false);
  const columns: any = getColumns(classes);
  const [inputText, setInputText] = React.useState('');
  const [participantData, setParticipantData] = React.useState<any>([]);

  const searchColumns = selectedKey === 'NO_RELATION' ? ['participantCode'] : ['providerCode'];

  useEffect(() => {
    setUserRole(userData?.userProfile?.roles?.[0]);
  }, [userData]);

  const newManageRelationActions: any = [
    {
      icon: () => (
        <ButtonGroup size="small" aria-label="outlined primary button group">
          <Button
            data-id="Enabled-ManageRelation"
            onClick={() => handleManageParticipantRelation('ENABLED')}
            variant={selectedKey === 'ENABLED' ? 'contained' : 'outlined'}
            color="primary"
          >
            Existing
          </Button>
          <Button
            data-id="Available-ManageRelation"
            onClick={() => handleManageParticipantRelation('NO_RELATION')}
            variant={selectedKey === 'NO_RELATION' ? 'contained' : 'outlined'}
            color="primary"
          >
            New
          </Button>
          <Button
            data-id="Available-ManageRelation"
            onClick={() => handleManageParticipantRelation('REQUESTED')}
            variant={selectedKey === 'REQUESTED' ? 'contained' : 'outlined'}
            color="primary"
          >
            Requested
          </Button>
        </ButtonGroup>
      ),
      isFreeAction: true,
      onClick: () => {}
    },
    participantType === 'CUSTOMER' &&
      props.workflowCode !== 'freightTracking' &&
      selectedKey === 'ENABLED' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'CUSTOMER' &&
      props.workflowCode !== 'freightTracking' &&
      selectedKey === 'NO_RELATION' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'CUSTOMER' &&
      props.workflowCode !== 'freightTracking' &&
      selectedKey === 'NO_RELATION' && {
        icon: () => <ArrowChevronsRight data-id="edit-enable-service" />,
        onClick: (event: any, rowData: any) => handleRequestDialog(rowData),
        tooltip: 'Request'
      },
    participantType === 'CUSTOMER' &&
      props.workflowCode !== 'freightTracking' &&
      selectedKey === 'REQUESTED' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'PROVIDER' &&
      props.workflowCode !== 'freightTracking' &&
      selectedKey === 'ENABLED' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'PROVIDER' &&
      props.workflowCode !== 'freightTracking' &&
      selectedKey === 'ENABLED' && {
        icon: () => <Edit data-id="edit-enable-service" />,
        onClick: (event: any, rowData: any) => handleManageParticipantEditDialog(rowData)
      },
    participantType === 'PROVIDER' &&
      props.workflowCode !== 'freightTracking' &&
      selectedKey === 'NO_RELATION' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'PROVIDER' &&
      props.workflowCode !== 'freightTracking' &&
      selectedKey === 'NO_RELATION' && {
        icon: () => <Link data-id="link-enable-service" />,
        onClick: (event: any, rowData: any) => handleManageParticipantEditDialog(rowData),
        tooltip: 'Connect Participants',
        position: 'row'
      },
    participantType === 'PROVIDER' &&
      props.workflowCode !== 'freightTracking' &&
      selectedKey === 'REQUESTED' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'PROVIDER' &&
      props.workflowCode !== 'freightTracking' &&
      selectedKey === 'REQUESTED' && {
        icon: () => <ArrowChevronsRight data-id="edit-enable-service" />,
        onClick: (event: any, rowData: any) => handleRequestDialog(rowData),
        tooltip: 'Accept'
      },
    participantType === 'CUSTOMER' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'ENABLED' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'CUSTOMER' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'NO_RELATION' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'CUSTOMER' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'NO_RELATION' && {
        icon: () => <ArrowChevronsRight data-id="edit-enable-service" />,
        onClick: (event: any, rowData: any) => handleRequestDialog(rowData),
        tooltip: 'Request'
      },
    // participantType === 'CUSTOMER' &&
    // props.workflowCode === 'freightTracking' &&
    // selectedKey === 'NO_RELATION' &&
    // {
    //   icon: () => (
    //     <Button
    //       data-id="Compare-Button"
    //       id="Compare-Button"
    //       disableElevation
    //       variant="contained"
    //       color="primary"
    //       onClick={handleRequestDialog}
    //     >
    //       Connect
    //     </Button>
    //   ),
    //   position: 'row'
    // },
    participantType === 'CUSTOMER' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'REQUESTED' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'PROVIDER' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'ENABLED' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'PROVIDER' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'ENABLED' && {
        icon: () => <Edit data-id="edit-enable-service" />,
        onClick: (event: any, rowData: any) => handleManageParticipantEditDialog(rowData),
        tooltip: 'Edit',
        position: 'row'
      },
    participantType === 'PROVIDER' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'NO_RELATION' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    // participantType === 'PROVIDER' &&
    // props.workflowCode === 'freightTracking' &&
    // selectedKey === 'NO_RELATION' &&
    // {
    //   icon: () => (
    //     <Button
    //       data-id="Compare-Button"
    //       id="Compare-Button"
    //       disableElevation
    //       variant="contained"
    //       color="primary"
    //       onClick={handleRequestDialog}
    //     >
    //       Connect
    //     </Button>
    //   ),
    //   position: 'row'
    // },
    participantType === 'PROVIDER' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'REQUESTED' && {
        icon: () => <ArrowChevronsRight data-id="edit-enable-service" />,
        onClick: (event: any, rowData: any) => handleRequestDialog(rowData),
        tooltip: 'Accept'
      },
    participantType === 'PROVIDER' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'REQUESTED' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'AGGREGATOR' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'ENABLED' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'AGGREGATOR' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'ENABLED' && {
        icon: () => <Edit data-id="edit-enable-service" />,
        onClick: (event: any, rowData: any) => handleManageParticipantEditDialog(rowData),
        tooltip: 'Edit',
        position: 'row'
      },
    participantType === 'AGGREGATOR' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'NO_RELATION' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      },
    participantType === 'AGGREGATOR' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'REQUESTED' && {
        icon: () => <ArrowChevronsRight data-id="edit-enable-service" />,
        onClick: (event: any, rowData: any) => handleRequestDialog(rowData),
        tooltip: 'Accept'
      },
    participantType === 'AGGREGATOR' &&
      props.workflowCode === 'freightTracking' &&
      selectedKey === 'REQUESTED' && {
        icon: () => <BubblesUsersCollab />,
        onClick: (event: any, rowData: any) => handleChatBox(rowData),
        tooltip: 'Notes',
        position: 'row'
      }
  ];

  const handleChatBox = (rowData: any) => {
    setFormData(rowData);
    setChatDialog(!chatDialog);
  };
  let [
    getCustomerProviderMappings,
    { loading, data: customerProviderData, refetch: customerProviderRefetch }
  ] = useLazyQuery(CUSTOMER_PROVIDER_RELATION_QUERY, {
    variables: { workflowCode: props.workflowCode, participantCode: participantCode },
    fetchPolicy: 'cache-first'
  });

  const {
    loading: subscribedParticipantLoading,
    data: subscribedParticipantData,
    refetch: subscribedParticipantRefresh
  } = useQuery(SUBSCRIBED_PARTICIPANT_WORKFLOW_QUERY, {
    variables: { participantCode: participantCode },
    fetchPolicy: 'cache-first',
    skip: !participantCode
  });

  const getAuthContext = () => {
    const auth = _.filter(subscribedParticipantData?.subscribedParticipantWorkflow?.content || [], (element: any) => {
      if (element.workflowCode === props.workflowCode) {
        return element;
      }
    });
    return auth;
  };

  const getParticipantType = () => {
    if (participantType === 'CUSTOMER') return 'PROVIDER';
    else return 'CUSTOMER';
  };

  const [
    getParticipantSubscribers,
    { loading: participantSubscriberLoading, data: participantSubscriberData, refetch: participantSubscriberRefetch }
  ] = useLazyQuery(PARTICIPANT_SUBSCRIBED_QUERY, {
    variables: {
      workflowCode: props.workflowCode,
      participantType: getParticipantType(),
      participantCode: participantCode,
      filterExistingParticipants: true
    },
    fetchPolicy: 'cache-first'
  });

  const [
    getAggregatorSubscribers,
    { loading: aggregatorSubscriberLoading, data: aggregatorSubscriberData, refetch: aggregatorSubscriberRefetch }
  ] = useLazyQuery(AGGREGATOR_SUBSCRIBED_QUERY, {
    variables: {
      workflowCode: props.workflowCode,
      participantCode: participantCode,
      filterExistingParticipants: true
    },
    fetchPolicy: 'cache-first'
  });

  const [
    getAggregatorProvidersData,
    { loading: aggregatorProviderDataLoading, data: aggregatorProviderData }
  ] = useLazyQuery(AGGREGATOR_PROVIDER_QUERY, {
    variables: {
      workflowCode: props.workflowCode,
      aggregatorCode: participantCode
    },
    fetchPolicy: 'cache-first'
  });
  const [
    getCustomerAggregatorData,
    { loading: customerAggregatorDataLoading, data: customerAggregatorData }
  ] = useLazyQuery(CUSTOMER_AGGREGATOR_QUERY, {
    variables: {
      workflowCode: props.workflowCode,
      aggregatorCode: participantCode
    },
    fetchPolicy: 'cache-first'
  });

  const handleManageParticipantRelation = (key: any) => {
    setSelectedKey(key);
    setInputText('');
    if (key === 'ENABLED') {
      getCustomerProviderMappings();
      getCustomerAggregatorData();
      setExistingDisable(true);
    } else if (key === 'NO_RELATION') {
      getParticipantSubscribers();
      getAggregatorSubscribers();
      setExistingDisable(false);
    }
  };

  const detailPanel = [
    {
      icon: () => (
        <div>
          <Tooltip title="Auth Context" aria-label="simple">
            <History />
          </Tooltip>
        </div>
      ),
      tooltip: 'Auth Context Details',
      openIcon: () => <ArrowChevronUp />,
      render: (rowData: any) => {
        return (
          <AuthContextDetailView
            {...rowData}
            workflowCode={props.workflowCode}
            participantCode={rowData?.participantCode}
            data={customerAggregatorData?.customerAgggregatorRelation?.content}
            loading={customerAggregatorDataLoading}
          />
        );
      }
    }
  ];

  const handleManageParticipantAddDialog = (rowData: any) => {
    rowData['partnerCode'] = rowData.participantCode;
    setIsEdit({});
    setFormData(rowData);
  };
  const getPartnerCode = (rowData: any) => {
    if (participantType === 'CUSTOMER') {
      return rowData.providerCode;
    } else return rowData.customerCode;
  };

  const handleManageParticipantEditDialog = (rowData: any) => {
    rowData.authContext = getAuthContext()?.[0];
    rowData['partnerCode'] = rowData.aggregatorCode === 'DEFAULT' ? getPartnerCode(rowData) : rowData.aggregatorCode;
    if (rowData.additionalCreds) {
      _.keys(rowData.additionalCreds || []).forEach(keyParameter => {
        const additionalParameterObj = rowData.additionalCreds[keyParameter];
        _.keys(additionalParameterObj || []).forEach(key => {
          if (key === 'secret') rowData[key] = decodeURI(additionalParameterObj[key]);
          rowData[key] = additionalParameterObj[key];
        });
      });
    }
    let obj: any = {};
    obj[rowData.partnerCode] = true;
    setIsEdit({ ...obj });
    setFormData(rowData);
    if ((rowData?.status === 'REQUESTED' || rowData?.status === 'ENABLED') && participantType !== 'PROVIDER') {
      const formData = rowData;
      formData['connectionNotes'] = formData?.connectionConfig
        ? formatString(formData?.connectionConfig)?.connectionNotes
        : '';
      formData['participantCode'] = participantCode;
      formData['participantType'] = participantType;
      setFormData(formData);
    }
    if (participantType === 'PROVIDER' && selectedKey === 'NO_RELATION') {
      setExistingDisable(true);
      rowData['partnerCode'] = participantType === 'PROVIDER' ? rowData?.participantCode : participantCode;
      rowData['customerCode'] = participantType === 'CUSTOMER' ? participantCode : rowData.participantCode;
      setFormData(rowData);
    }
    if (rowData?.status === 'REQUESTED') {
      setRequestDialog(!requestDialog);
    } else {
      setManageRelation(true);
    }
  };

  const handleRequestDialog = (rowData: any) => {
    rowData['partnerCode'] = rowData.participantType === 'AGGREGATOR' ? rowData.participantCode : participantCode;
    rowData['customerCode'] = participantType === 'CUSTOMER' ? participantCode : rowData.customerCode;
    setFormData(rowData);
    setRequestDialog(!requestDialog);
    let obj: any = {};
    obj[rowData.partnerCode] = true;
    setIsEdit({ ...obj });
  };

  const handleManageParticipantDialogClose = () => {
    setManageRelation(false);
  };
  const handleManageParticipantDialogSubmit = () => {
    setManageRelation(false);
  };

  useEffect(() => {
    if (participantType === 'AGGREGATOR') {
      getAggregatorProvidersData();
    } else if (participantType === 'CUSTOMER_AGGREGATOR') {
      getCustomerAggregatorData();
    } else {
      getCustomerProviderMappings();
    }
    getParticipantSubscribers();
  }, [
    getAggregatorProvidersData,
    getCustomerAggregatorData,
    getCustomerProviderMappings,
    getParticipantSubscribers,
    participantType,
    selectedKey
  ]);

  const getManageRelationData = () => {
    if (selectedKey === 'ENABLED') {
      let participantData: any = [];
      let contextDataList: any = {};
      let contextData: any = [];
      switch (participantType) {
        case 'AGGREGATOR':
          participantData = !aggregatorSubscriberLoading ? aggregatorSubscriberData?.aggregatorSubscribed : [];
          break;
        case 'PROVIDER':
          participantData = !loading ? customerProviderData?.customerProviderRelation : [];
          break;
        case 'CUSTOMER':
          participantData = !loading ? customerProviderData?.customerProviderRelation : [];
          break;
        case 'CUSTOMER_AGGREGATOR':
          participantData = !customerAggregatorDataLoading
            ? customerAggregatorData?.customerAgggregatorRelation?.content
            : [];

          _.keys(participantData || []).forEach(key => {
            const obj = participantData[key]?.participantCode;
            contextDataList[obj] = obj;
          });
          _.keys(contextDataList || []).forEach(key => {
            contextData.push({ participantCode: key });
          });
      }
      return participantType === 'CUSTOMER_AGGREGATOR'
        ? contextData
        : participantData?.filter((item: any) => item.status === selectedKey);
    } else if (selectedKey === 'NO_RELATION') {
      let participants = participantSubscriberData?.participantSubscribed?.map((item: any) => {
        item['providerCustomerCode'] = item.participantCode;
        return item;
      });

      aggregatorSubscriberData?.aggregatorSubscribed?.map((item: any) => {
        item['providerCustomerCode'] = item.participantCode;
        return item;
      });
      let providerList = !participantSubscriberLoading ? participants : [];
      if (props.workflowCode === 'freightTracking') {
        aggregatorSubscriberData?.aggregatorSubscribed?.map((item: any) => {
          item['providerCustomerCode'] = item.participantCode;
          providerList.push(item);
        });
      }

      return providerList;
    } else if (selectedKey === 'REQUESTED') {
      const participants = customerProviderData?.customerProviderRelation?.filter(
        (item: any) => item.status === selectedKey
      );
      let providerList = !loading ? participants : [];
      return providerList;
    }
  };

  const onClearText: any = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setInputText('');
    // setParticipantData(data?.participantInfo?.content);
  };

  const onSearchChange = (searchKey: string) => {
    setInputText(searchKey);
    const participantResult = getManageRelationData();
    const filteredData = participantResult?.filter((row: any) => {
      return String(searchColumns.map(column => String(row[column]).toLowerCase())).includes(searchKey.toLowerCase());
    });
    setParticipantData(filteredData);
  };

  return (
    <div>
      <ManageRelationDialog
        selectedKey={selectedKey}
        dialogOpen={manageRelation}
        handleDialogClose={handleManageParticipantDialogClose}
        formData={formData}
        edit={isEdit}
        handleDialogSubmit={handleManageParticipantDialogSubmit}
        customerProviderRefresh={customerProviderRefetch}
        participantSubscriberRefresh={participantSubscriberRefetch}
        aggregatorSubscriberRefresh={aggregatorSubscriberRefetch}
        participant={props.participant}
        workflowCode={props.workflowCode}
        participantCode={userData?.userProfile?.participantRoleInfos?.[0]?.participant?.participantCode}
        existingDisable={existingDisable}
        supportUser={userRole !== 'APP_ADMIN' ? true : false}
        userRole={userRole}
      />
      <Requested
        dialogOpen={requestDialog}
        handleDialogClose={() => {
          setRequestDialog(!requestDialog);
        }}
        participantType={participantType}
        formData={formData}
        workflowCode={props.workflowCode}
        customerProviderRefresh={customerProviderRefetch}
        participantSubscriberRefresh={participantSubscriberRefetch}
        aggregatorSubscriberRefresh={aggregatorSubscriberRefetch}
        selectedKey={selectedKey}
        userRole={userRole}
      />
      <Chat
        handleDialogClose={() => setChatDialog(!chatDialog)}
        formData={formData}
        dialogOpen={chatDialog}
        participantType={participantType}
        workflowCode={props.workflowCode}
      />
      {loading || participantSubscriberLoading || aggregatorSubscriberLoading || customerAggregatorDataLoading ? (
        <Loading />
      ) : (
        <DetailedTable
          key={`ManageRelations-${selectedKey}`}
          id="ManageRelations"
          title=""
          columns={
            columns[props.workflowCode === 'freightTracking' ? 'FT' : 'NON_FT'][participantType][selectedKey] || []
          }
          data={inputText === '' ? getManageRelationData() : participantData}
          showSelection={false}
          tableActions={newManageRelationActions}
          detailPanel={participantType === 'CUSTOMER_AGGREGATOR' && selectedKey === 'ENABLED' ? detailPanel : []}
          showPagination={true}
          page={0}
          rowsPerPage={10}
          showTopPagination={true}
          showSearch={true}
          inputText={inputText}
          onClearText={onClearText}
          onSearchChange={onSearchChange}
          showSorting={selectedKey === 'ENABLED' ? true : false}
        />
      )}
    </div>
  );
};
export default ManageRelations;
